<template>
	<div class="m-doc-base">
		<div v-if="$scopedSlots.title" class="title"><slot name="title"></slot></div>

		<div class="info">
			<slot name="info"></slot>
		</div>

		<p v-if="status == 2" class="state" style="color: #00ACA9;">审批通过</p>
		<p v-else-if="status == 3" class="state" style="color: #FF5555;">审批驳回</p>
		<p v-else-if="status == 1 && approver" class="state" style="color: #FF6900;">等待【{{approver}}】处理</p>

		<i v-if="status == 2" class="state-icon tf" style="color: #48CE81;">&#xe771;</i>
		<i v-else-if="status == 3" class="state-icon tf" style="color: #FF5555;">&#xe770;</i>
	</div>
</template>

<script>
	export default {
		name: 'docBase',

		data() {
			return {
				status: '',
				approver: ''
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-doc-base {
		position: relative;
		border-radius: .16rem;
		padding: .3rem .38rem .4rem;
		margin: 0 .2rem .2rem;
		background: linear-gradient(0deg, #FFFFFF, #EEFAFF);

		&:nth-child(1) {
			margin-top: .2rem;
		}

		.title {
			line-height: .52rem;
			font-size: .36rem;
			font-weight: bold;
			word-break: break-word;
		}

		.info {
			margin-top: .12rem;

			>>> .c-field {
				&-label {
					color: #666;
				}

				&-content {
					color: #666;
				}
			}
		}

		.state {
			margin-top: .16rem;
			font-size: .28rem;

			&-icon {
				position: absolute;
				right: .28rem;
				top: .2rem;
				font-size: 1.4rem;
			}
		}
	}
</style>
